import { render, staticRenderFns } from "./SimpleTrunkAnalysis.vue?vue&type=template&id=1449b397&scoped=true"
import script from "./SimpleTrunkAnalysis.vue?vue&type=script&lang=ts"
export * from "./SimpleTrunkAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./SimpleTrunkAnalysis.vue?vue&type=style&index=0&id=1449b397&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1449b397",
  null
  
)

export default component.exports